import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import headerLogo from './../../../assets/new-logo.svg';
import { Button, FormGroup, FormControl } from "react-bootstrap";
import {Link, withRouter} from "react-router-dom";
import "./password-reset.scss";
import { toast } from 'react-toastify';
import * as api from "../../../api";
import { Divider } from 'semantic-ui-react';


function mapStateToProps(state) {
    return {

    };
}

class PasswordReset extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            email: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        api.resetPassword(this.state.email)
            .then(() => {
                toast.info("An email will be sent including password reset instructions", {
                    position: toast.POSITION.TOP_RIGHT,
                    onClose: () => { this.props.history.push("/"); }
                });
            });
    }

    render() {
        return (
            <div className="login">

                <Helmet>
                    <title>Inenco Portal | Forgot Password</title>
                </Helmet>

                <img src={headerLogo} alt="header-logo" className="login-logo" />
                <h4>Password Reset</h4>
                <p>Please enter your e-mail below and we&apos;ll be in touch shortly:</p>
                
                <form onSubmit={this.handleSubmit}>
                    <FormGroup controlId="email" bsSize="large">
                        <FormControl
                            autoFocus
                            type="email"
                            placeholder="E-mail address"
                            onChange={this.handleChange}
                            className="username"
                            required
                        />
                    </FormGroup>
                    <div className="button-div">
                        
                     
                        <Button
                            block
                            bsSize="large"
                            type="submit"
                            className="reset-button"
                            >
                            Reset Password
                        </Button>
                        
                        
                        
                                               
                    </div>
                </form>
                
                <Divider section></Divider>

                <Link to="/">
                    <Button
                        block
                        bsSize="large"
                        type="button"
                        className="cancel-button"
                        >
                        Return to login page
                    </Button>
                </Link> 
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(withRouter(PasswordReset));